import {Controller} from "@hotwired/stimulus";
import TomSelect from "tom-select";

export default abstract class BaseSelectController extends Controller {
  private select: TomSelect | null = null;

  /**
   * Derived controllers must provide the URL to fetch data.
   */
  abstract get url(): string;

  /**
   * Optionally override this method to provide a custom template
   * for formatting Tom Select results.
   */
  renderOption?(item: any, escape: (str: string) => string): string;

  /**
   * Determines if the select should allow multiple selections.
   * Override in the derived controller to enable multiselect.
   */
  get multiple(): boolean {
    return false;
  }

  connect(): void {
    const config: any = {
      valueField: 'id',
      labelField: 'text',
      searchField: 'text',
      loadThrottle: 250,
      allowEmptyOption: true,
      preload: true,
      render: {
        no_results: function(_data: any, _escape: any){
          return '<div class="no-results">Ничего не найдено</div>';
        },
      },
      load: (query: string, callback: (data: any) => void) => {
        fetch(`${this.url}?search=${encodeURIComponent(query)}`)
          .then(response => response.json())
          .then(data => {
            callback(data.items);
          })
          .catch(() => {
            callback([]);
          });
      },
      onInitialize: () => {
        this.element.classList.remove("is-invalid");
      },
      onChange: () => {
        this.element.classList.remove("is-invalid");
      }
    };

    // Include the multiple option if required by the derived controller.
    if (this.multiple) {
      config.maxItems = null; // Allow unlimited selections
    }

    // If the derived controller provides a renderOption function, use it
    if (this.renderOption) {
      config.render = {
        option: this.renderOption
      };
    }

    this.select = new TomSelect(this.element as HTMLSelectElement, config);
  }

  disconnect(): void {
    if (this.select) {
      this.select.destroy();
      this.select = null;
    }
  }
}